/* Frenly Bricks mobile product purchase bar. */
(function () {
  'use strict';

  function compactText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  /* T-PDP5 (v2.35): free AU shipping remainder line under the sticky
     bar's price, read from /cart.js once on load and again after an add
     to cart. Presentation only, no shipping rate engine involved -- the
     same fb_free_shipping_threshold setting the cart page and PDP
     shipping line already use, passed down via data-fb-ship-threshold.

     F26/F34: built as a plain "$" string rather than through
     Intl.NumberFormat's currency style -- that style prints "A$" for the
     AUD currency code in several locales, which read as a typo next to
     the plain "$20.00" money format used everywhere else on the site.
     Whole dollars print with no decimals ("$40"); a remainder that is
     not a whole dollar keeps two decimal places ("$40.50") instead of
     always rounding them away. */
  function formatDollars(cents) {
    var dollars = cents / 100;
    if (cents % 100 === 0) {
      return '$' + Math.round(dollars);
    }
    return '$' + dollars.toFixed(2);
  }

  var shippingReadVersions = new WeakMap();
  function renderShipLine(shipLineEl, threshold) {
    if (!shipLineEl) return;
    var version = (shippingReadVersions.get(shipLineEl) || 0) + 1;
    shippingReadVersions.set(shipLineEl, version);
    shipLineEl.textContent = '';
    if (!Number.isFinite(threshold) || threshold <= 0) return;
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart read failed');
        return res.json();
      })
      .then(function (cart) {
        if (shippingReadVersions.get(shipLineEl) !== version) return;
        if (!cart || cart.currency !== 'AUD' || !Number.isInteger(cart.item_count) || cart.item_count <= 0
          || !Number.isSafeInteger(cart.total_price) || cart.total_price < 0) return;
        var thresholdCents = Math.round(threshold * 100);
        var remainingCents = thresholdCents - cart.total_price;
        if (remainingCents <= 0) {
          shipLineEl.textContent = 'Free AU shipping unlocked';
          return;
        }
        shipLineEl.textContent = formatDollars(remainingCents) + ' to free AU shipping';
      })
      .catch(function () {
        // Never retain an unverified previous-cart shipping promise.
        if (shippingReadVersions.get(shipLineEl) === version) shipLineEl.textContent = '';
      });
  }

  function bindShippingUpdates(bar, shipLineEl, threshold) {
    if (!shipLineEl) return function () {};
    var disposed = false;
    var unsubscribe = null;
    function invalidate() {
      shippingReadVersions.set(shipLineEl, (shippingReadVersions.get(shipLineEl) || 0) + 1);
      shipLineEl.textContent = '';
    }
    function refresh() {
      if (disposed || bar.isConnected === false) return;
      return renderShipLine(shipLineEl, threshold);
    }
    function onSubmit(event) {
      var form = event.target;
      if (form && form.action && form.action.indexOf('/cart/add') !== -1) invalidate();
    }
    function onVisible() {
      if (document.visibilityState === 'visible') refresh();
    }
    function onUnload(event) {
      if (event.target && event.target.contains(bar)) dispose();
    }
    function dispose() {
      if (disposed) return;
      disposed = true;
      if (unsubscribe) unsubscribe();
      invalidate();
      document.removeEventListener('submit', onSubmit, true);
      document.removeEventListener('visibilitychange', onVisible);
      document.removeEventListener('shopify:section:unload', onUnload);
      window.removeEventListener('pageshow', refresh);
    }
    // Native cart events occur after successful add, change and removal.
    // A timer after submit cannot establish that the mutation finished.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    }
    document.addEventListener('submit', onSubmit, true);
    document.addEventListener('visibilitychange', onVisible);
    document.addEventListener('shopify:section:unload', onUnload);
    window.addEventListener('pageshow', refresh);
    refresh();
    return dispose;
  }

  function init(bar) {
    if (!bar || bar.dataset.fbReady === 'true') return;
    bar.dataset.fbReady = 'true';
    var disposed = false;
    var headerObserver = null;
    var productObserver = null;
    var barObserver = null;
    var animationFrame = null;

    /* VF73: --fb-buybar-h feeds assets/frenly-safe-area.css so the Inbox
       chat launcher lifts clear of this bar by the bar's real measured
       height, not a guessed constant. */
    function measureBuybarHeight() {
      if (disposed || bar.isConnected === false) return;
      document.documentElement.style.setProperty('--fb-buybar-h', Math.ceil(bar.getBoundingClientRect().height) + 'px');
    }
    measureBuybarHeight();
    if ('ResizeObserver' in window) {
      barObserver = new ResizeObserver(measureBuybarHeight);
      barObserver.observe(bar);
    }

    var sectionId = bar.dataset.section;
    var barPrice = bar.querySelector('[data-fb-mobile-price]');
    var barButton = bar.querySelector('[data-fb-mobile-submit]');
    var barStatus = bar.querySelector('[data-fb-mobile-status]');
    var barShipLine = bar.querySelector('[data-fb-mobile-shipline]');
    var shipThreshold = Number(bar.dataset.fbShipThreshold);
    var mainSection = document.getElementById('MainProduct-' + sectionId);
    var leadPrice = mainSection && mainSection.querySelector('.fb-product-mobile-lead__price');
    var leadStatus = mainSection && mainSection.querySelector('.fb-product-mobile-lead__stock');
    var productInfo = document.getElementById('ProductInfo-' + sectionId);
    var disposeShipping = bindShippingUpdates(bar, barShipLine, shipThreshold);

    var headerElement = document.querySelector('.section-header');
    function measureHeader() {
      if (disposed || bar.isConnected === false || !headerElement) return;
      document.documentElement.style.setProperty('--fb-product-header-height', Math.ceil(headerElement.getBoundingClientRect().height) + 'px');
    }
    // Header rows/fonts can settle after Dawn's initial height measurement.
    measureHeader();
    if ('ResizeObserver' in window && headerElement) {
      headerObserver = new ResizeObserver(measureHeader);
      headerObserver.observe(headerElement);
    }
    window.addEventListener('resize', measureHeader);

    function getMainButton() {
      return document.getElementById('ProductSubmitButton-' + sectionId)
        || document.querySelector('#product-form-' + sectionId + ' .product-form__submit');
    }

    function getCurrentPrice() {
      var priceRoot = document.getElementById('price-' + sectionId);
      if (!priceRoot || priceRoot.hidden || priceRoot.classList.contains('visibility-hidden')) return '';

      var onSale = priceRoot.querySelector('.price--on-sale');
      var priceNode = onSale
        ? priceRoot.querySelector('.price__sale .price-item--sale')
        : priceRoot.querySelector('.price__regular .price-item--regular');

      return compactText((priceNode || priceRoot).textContent);
    }

    function getCurrentStatus(mainButton) {
      if (!mainButton) return 'Unavailable';
      var labelNode = mainButton.querySelector('span');
      var label = compactText(labelNode && labelNode.textContent);
      var disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
      if (mainButton.classList.contains('loading') || mainButton.getAttribute('aria-busy') === 'true') return 'Updating selection';
      if (disabled) {
        // Dawn disables the button before its variant response arrives, while
        // retaining the old add label. Never retain a scarcity count then.
        var addLabel = window.variantStrings && window.variantStrings.addToCart;
        return !label || label === addLabel || label === 'Add to cart' ? 'Updating selection' : label;
      }
      // 16 Oct 2026: the stock line ("Low stock: 1 left") is no longer copied
      // into the bar. The page already says it once, in the LAST ONE notice
      // under the price.
      return 'Available';
    }

    function setText(node, value) {
      if (node && node.textContent !== value) node.textContent = value;
    }

    function sync() {
      if (disposed || bar.isConnected === false) return;
      var mainButton = getMainButton();
      var price = getCurrentPrice();
      var status = getCurrentStatus(mainButton);

      setText(barPrice, price);
      setText(leadPrice, price);
      // The bar shows a status line only when it means something (updating,
      // sold out). Plain "Available" stays off the bar.
      setText(barStatus, status === 'Available' ? '' : status);
      setText(leadStatus, status);
      if (leadStatus) leadStatus.classList.toggle('fb-product-mobile-lead__stock--ready', status === 'Available');
      if (!barButton) return;
      if (!mainButton) {
        barButton.disabled = true;
        return;
      }

      var mainLabel = mainButton.querySelector('span');
      barButton.disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true'
        || mainButton.classList.contains('loading') || mainButton.getAttribute('aria-busy') === 'true';
      barButton.setAttribute('form', mainButton.getAttribute('form') || ('product-form-' + sectionId));

      if (mainLabel) {
        barButton.textContent = compactText(mainLabel.textContent);
      }
    }

    // "Gymshark rule" (QA loop 1, 2026-09-10 fix): the sticky bar exists
    // only to keep an add-to-cart button reachable while the real in-page
    // buy box is not on screen -- it must never sit on top of the real one.
    //
    //   - Hidden the instant any part of the real button is inside the
    //     viewport (the shopper already sees a real button, a second one
    //     stacked on it is redundant).
    //   - Visible the instant the real button is entirely out of the
    //     viewport, whichever direction: not yet scrolled to (still below
    //     the fold) OR already scrolled past it (now above the fold).
    //   - This is a live "is the real button intersecting the viewport
    //     right now" check on every scroll/resize, not a one-way latch, so
    //     scrolling back up to the buy box hides the bar again, and
    //     scrolling back down past it once more re-shows it.
    //
    // The previous version only covered the "not yet scrolled to" half of
    // that (`rect.top >= window.innerHeight`), so once a shopper actually
    // scrolled past the real button the bar dropped out instead of
    // appearing, exactly backwards from the intent above.
    var ticking = false;

    function updateVisibility() {
      animationFrame = null;
      ticking = false;
      if (disposed || bar.isConnected === false) return;
      var mainButton = getMainButton();
      if (!mainButton) {
        bar.classList.remove('is-visible');
        bar.inert = true;
        document.documentElement.classList.remove('fb-has-mobile-buybar');
        return;
      }

      var rect = mainButton.getBoundingClientRect();
      var header = document.querySelector('.section-header');
      var headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      var notYetReached = rect.top >= window.innerHeight;
      var scrolledPast = rect.bottom <= headerBottom;
      var active = document.activeElement;
      var editing = active && active.matches('input, textarea, select, [contenteditable="true"]');
      var keyboardFocusOutside = active && !bar.contains(active)
        && active.matches('a:focus-visible, button:focus-visible, summary:focus-visible');
      var keyboardViewport = window.visualViewport
        && window.visualViewport.height < window.innerHeight - 100;
      var modalOpen = document.body.classList.contains('overflow-hidden')
        || document.body.classList.contains('overflow-hidden-mobile')
        || document.body.classList.contains('overflow-hidden-tablet');
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      var showBar = mobile && !editing && !keyboardFocusOutside && !keyboardViewport
        && !modalOpen && (notYetReached || scrolledPast);
      bar.classList.toggle('is-visible', showBar);
      // Opacity and pointer-events alone leave a hidden submit button tabbable.
      bar.inert = !showBar;
      document.documentElement.classList.toggle('fb-has-mobile-buybar', showBar);
    }

    function requestVisibilityUpdate() {
      if (disposed || bar.isConnected === false || ticking) return;
      ticking = true;
      if ('requestAnimationFrame' in window) {
        animationFrame = window.requestAnimationFrame(updateVisibility);
      } else {
        updateVisibility();
      }
    }

    window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
    window.addEventListener('resize', requestVisibilityUpdate);
    document.addEventListener('focusin', requestVisibilityUpdate);
    document.addEventListener('focusout', requestVisibilityUpdate);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', requestVisibilityUpdate);

    if ('MutationObserver' in window && productInfo) {
      productObserver = new MutationObserver(function () {
        sync();
        requestVisibilityUpdate();
      });
      productObserver.observe(productInfo, { childList: true, subtree: true, characterData: true, attributes: true });
    }

    function onSectionUnload(event) {
      if (!event.target || !event.target.contains(bar)) return;
      disposed = true;
      disposeShipping();
      if (headerObserver) headerObserver.disconnect();
      if (productObserver) productObserver.disconnect();
      if (barObserver) barObserver.disconnect();
      if (animationFrame !== null && window.cancelAnimationFrame) window.cancelAnimationFrame(animationFrame);
      window.removeEventListener('resize', measureHeader);
      window.removeEventListener('scroll', requestVisibilityUpdate);
      window.removeEventListener('resize', requestVisibilityUpdate);
      document.removeEventListener('focusin', requestVisibilityUpdate);
      document.removeEventListener('focusout', requestVisibilityUpdate);
      document.removeEventListener('shopify:section:unload', onSectionUnload);
      if (window.visualViewport) window.visualViewport.removeEventListener('resize', requestVisibilityUpdate);
      bar.classList.remove('is-visible');
      bar.inert = true;
      delete bar.dataset.fbReady;
      var anotherVisibleBar = document.querySelector('[data-fb-mobile-buybar].is-visible');
      document.documentElement.classList.toggle('fb-has-mobile-buybar', !!anotherVisibleBar);
    }
    document.addEventListener('shopify:section:unload', onSectionUnload);

    sync();
    updateVisibility();
  }

  function boot(scope) {
    var root = scope || document;
    var bars = root.querySelectorAll('[data-fb-mobile-buybar]');
    for (var i = 0; i < bars.length; i++) init(bars[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
